import { render, staticRenderFns } from "./RevenueBreakupDetailedInformation.vue?vue&type=template&id=034f8595&scoped=true"
import script from "./RevenueBreakupDetailedInformation.vue?vue&type=script&lang=js"
export * from "./RevenueBreakupDetailedInformation.vue?vue&type=script&lang=js"
import style0 from "./RevenueBreakupDetailedInformation.vue?vue&type=style&index=0&id=034f8595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034f8595",
  null
  
)

export default component.exports